import { mapActions, mapState } from 'vuex';
import disqusMixin from '@/mixins/disqus';

export default {
  mixins: [
    disqusMixin,
  ],
  props: {
    market: {
      type: Object,
      required: true,
    },
    showInfoOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('market', ['isDiscussionPinned'])
  },
  methods: {
    ...mapActions('market', ['toggleDiscussionPin'])
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/page-market-detail-sushi/components/sushi-market-discussion-widget/sushi-market-discussion-widget.js